import { SET_DEFAULT_COLOR, SET_DEFAULT_SYSTEM } from "../actions/defaults";

const defaultsReducer = (state = { color: null, system: null }, action) => {
  switch (action.type) {
    case SET_DEFAULT_COLOR:
      return Object.assign({}, state, {
        color: action.value
      });
    case SET_DEFAULT_SYSTEM:
      return Object.assign({}, state, {
        system: action.value
      });
    default:
      return state;
  }
};

export default defaultsReducer;
